import { gql } from "@apollo/client/core";

const GetRecentProjectsQuery = gql`
  query GetRecentProjects($limit: Int = 5, $tenantId: String!) {
    userProjectView(
      where: { project: { tenantId: { _eq: $tenantId }, deletedBy: { _is_null: true } } }
      order_by: { viewedAt: desc }
      limit: $limit
    ) {
      projectId
      viewedAt
      project {
        id
        name
        projectStatus {
          id
        }
      }
    }
  }
`;

export default GetRecentProjectsQuery;
